import React from "react";
import OperationSites from "../../../components/Dashboards/Operations/sites";
import { useParams, useSearchParams } from "react-router-dom";
function OperationsSitePage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const isFromFinance = searchParams.get("isFromFinance") === "true";
  return (
    <OperationSites company_id={id as string} isFromFinance={isFromFinance} />
  );
}

export default OperationsSitePage;
